import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderService, LoaderState } from '@app/core/services/loader/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {

  show = false;
  message = '';
  subtitle = '';
  progressCurrent: number | null = null;
  progressTotal: number | null = null;
  subscription!: Subscription;

  constructor(private loaderService: LoaderService) {
   }

  get progressText(): string | null {
    if (this.progressCurrent !== null && this.progressTotal !== null) {
      return `${this.progressCurrent} / ${this.progressTotal}`;
    }
    return null;
  }

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
    .subscribe((state: LoaderState) => {
      this.show = state.show;
      this.message = state.message || '';
      this.subtitle = state.subtitle || '';
      this.progressCurrent = state.progressCurrent !== undefined ? state.progressCurrent : null;
      this.progressTotal = state.progressTotal !== undefined ? state.progressTotal : null;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
